import React, { useRef, useState } from "react";
import { Titillium_Web } from "next/font/google";
import { Button } from "../../Button";
import { Input } from "../../Input";
const tw = Titillium_Web({ weight: ["300", "400"], subsets: ["latin"] });
import { Callout } from "../../Callout";
import { Select } from "../../Select";
import { rudderStackTrack } from "../../Track";
import ACTIONS from "../../EventLibrary";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import Script from "next/script";
import { Flex } from "@radix-ui/themes";


export default function LandingPage() {
    const [wallet, setWallet] = useState("");
    const [response, setResponse] = useState<any>({success: null, message: "", txn_hash: ""});
    const [chain, setChain] = useState("linea-testnet");
    const [loading, setLoading] = useState(false);
    const [token, setToken] = useState<any>(null);

    const checkIfValidBlockchainAddress = (address) => {
        if (address.length !== 42) return false;
        if (address.slice(0, 2) !== "0x") return false;
        return true;
    };

    const handleFormSubmit = async () => {
        rudderStackTrack(ACTIONS.platform_faucet_submitted, {
            email: wallet,
        });
        setLoading(true);
        const body = {
            "event": {
                "token": token,
                "siteKey": "87c054d9-76d3-4c89-b6d0-281a2d0c1acc",
                "expectedAction": "FAUCET_SUBMIT"
            },
        };

        try {
            const resp = await fetch(`https://covalent-testnet-faucet.vercel.app/${chain}/transfer/${wallet}`,
                {
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            resp.json().then((data) => {
                if (data.status === "success") {
                    setResponse({success: true, message: "Success! Tokens will be sent to your wallet shortly.", txn_hash: data.message});
                    setLoading(false);
                    rudderStackTrack(ACTIONS.platform_faucet_success, {
                        txn_hash: data.message,
                        status: "success",
                    });
                } else {
                    setResponse({success: false, message: (typeof data?.message === "string" && data?.message) || "Something went wrong. Please try again.", txn_hash: ""});
                    setLoading(false);
                    rudderStackTrack(ACTIONS.platform_faucet_success, {
                        message: data.message,
                        status: "failure",
                    });
                }
                setLoading(false);
            }).catch(() => {
                setResponse({success: false, message: "Something went wrong. Please try again.", txn_hash: ""});
                setLoading(false);
                rudderStackTrack(ACTIONS.platform_faucet_success, {
                    message: "Something went wrong. Please try again.",
                    status: "failure",
                });
            });
            setLoading(false);
        } catch (err) {
            setLoading(false);
        }
    };

    const handleSelectChain = (e) => {
        setChain(e.target.value);
    };
  
    const handleChange = (e) => {
        setWallet(e.target.value);
    };

    const captchaRef: any = useRef(null);


    return <><Script src="https://js.hcaptcha.com/1/api.js" strategy="afterInteractive" async defer></Script><div className="platform-page">
        <Flex gap="3" direction={"column"} className="light">
            <div className="card">
                <Flex gap="3" direction={"column"}>
               
                    <div>
                        <h3>Select a Network for Test Tokens:</h3>
                    </div>

                    <Select onChange={handleSelectChain} id="platform">
                        <option value="linea-testnet">Linea Testnet</option>
                        <option value="base-testnet">Base Testnet</option>
                        <option value="mantle-testnet">Mantle Testnet</option>
                        <option value="scroll-alpha-testnet">Scroll Alpha Testnet</option>
                        <option value="scroll-sepolia-testnet">Scroll Sepolia Testnet</option>
                        <option value="horizen-gobi-testnet">Horizen Gobi Testnet</option>
                        <option value="optimism-goerli-testnet">Optimism Goerli Testnet</option>
                        <option value="zetachain-testnet">ZetaChain Testnet</option>
                        <option value="arbitrum-goerli-testnet">Arbitrum Goerli Testnet</option>
                        <option value="polygon-mumbai">Polygon Mumbai Testnet</option>
                        <option value="avalanche-testnet">Avalanche Fuji Testnet</option>
                        <option value="cronos-testnet">Cronos Testnet</option>
                        <></>
                    </Select>
               
                    <div>
                        <h3>Enter Your Wallet Address:</h3>
                    </div>
               
                    <div className="posts-wrapper">
                        <Input onChange={handleChange} type="text" id="wallet-address" placeholder="0x1234567..." />
                        <br />
                        <HCaptcha
                            sitekey="87c054d9-76d3-4c89-b6d0-281a2d0c1acc"
                            onVerify={setToken}
                            ref={captchaRef} />
                        {((!response.success && !loading) && <><br /><Button onClick={handleFormSubmit} disabled={!checkIfValidBlockchainAddress(wallet) || token === null}>
                                    Send Tokens to Wallet
                        </Button></>)}
                        {(loading && <><br /><Button load={true} disabled={!wallet.length}>Send Tokens to Wallet</Button></>)}
                    </div>
                
                    {((response.success && response.success !== null) && <Callout type="check" title={"Success"}>
                        <p>{response.message}</p>
                        <a target="_blank" href={response.txn_hash}>See transaction hash</a>
                    </Callout>)}
                    {((!response.success && response.success !== null) && <Callout type="error" title={"Error"}>
                        <p>{response.message}</p>
                    </Callout>)}
            
                </Flex>
            </div>
        </Flex>

        <style jsx>
            {`
                    .ch-hr {
                    margin-bottom: 2rem;
                    }
                    
                    
                    .selector-card {
                        background: var(--code-background);
                        border: 1px solid var(--code-border);
                        padding: 1rem;
                        border-radius: var(--border-radius);
                    }
                    h3 {
                        margin-top: 0;
                    }
                    .gap {
                    margin-top: 1rem;
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    }
                    h2 {
                    margin-bottom: 1rem;
                    }
                    .clickable{
                    color: var(--pink);
                    }
                    .clickable:hover{
                    cursor:pointer;
                    }
                    .flex {
                    display: flex;
                    gap: 1rem;
                    flex-wrap: wrap;
                    }

                    .hr-auth {
                    margin-left: 2rem;
                    margin-right: 2rem;
                    }

                    .top {
                    max-width: 1440px;
                    padding: 0rem;
                    margin-top: 2rem;
                    }
                    .flex div:first-of-type {
                    flex: 1 1 60%;
                    }
                    .flex div:last-of-type {
                    flex: 1 1 0%;
                    }
                    .title-side {
                    display: flex;
                    place-items: center;
                    margin-top: 2rem;
                    }
                    .title-side h2{
                    margin-top: 0 !important;
                    display: block;
                    margin-right: auto;
                    }
                    .title-side a {
                    color: var(--pink);
                    text-decoration: none;
                    font-family: ${tw.style.fontFamily} , sans-serif;
                    }

                    .chart-buttons {
                    display: flex;
                    place-items: center;
                    border-radius: var(--border-radius);
                    overflow: hidden;
                    cursor: pointer;
                    }
                    
                    .chart-buttons .selected {
                    background: var(--pink);
                    padding: 10px 10px 5px 10px;
                    color: white;
                    }
                    
                    .chart-buttons div:not(.selected) {
                    padding: 10px 10px 5px 10px;
                    background: white;
                    color: black;
                    stroke: black;
                    }

                    .chart-buttons div:hover {
                    background: black !important;
                    color: white !important;
                    }

                    .main {
                    padding: 2rem;
                    padding-top: 0;
                    display: flex;
                    width: 100%;
                    // background: var(--gray);
                    gap: 2rem;
                    // overflow: auto;
                    flex-wrap: wrap;
                    max-width: 1440px;
                    }

                    .overflow {
                    background: var(--gray);
                    width: 100vw;
                    height: 100vh;
                    position: sticky;
                    top: 0;
                    min-width: 0;
                    flex: 1 1 0%;
                    }

                    .col-1 {
                    flex: 1 1 0px;
                    width: 100%;
                    min-width: 200px;
                    }

                    .col-2 {
                    flex: 1 1 0px;
                    width: 100%;
                    min-width: 200px;
                    // max-width: 470px;
                    }

                    .covalent-logo {
                    width: 100%;
                    padding: 1.5rem 2rem;
                    color: white;
                    display: flex;
                    place-items: center;
                    gap: 0.5rem;
                    font-family: ${tw.style.fontFamily} , sans-serif;
                    font-size: var(--font-size-4)
                    }

                    .cards-wrapper {
                    display: flex;
                    gap: 1rem;
                    margin-top: 1rem;
                    flex-wrap: wrap;
                    }

                    .link-wrapper {
                    display: flex;
                    gap: 1rem;
                    // margin-top: 1rem;
                    flex-wrap: wrap;
                    flex-direction: column;
                    }

                    .wrapper {
                    display: flex;
                    }

                    .posts-wrapper {
                        border-radius: var(--border-radius);
                    }

                `}
        </style>
    </div></>;
}